import { TOGGLE_THEME, SET_THEME } from './types';

// Toggle between light and dark theme
export const toggleTheme = () => dispatch => {
  const currentTheme = localStorage.getItem('theme') || 'light';
  const newTheme = currentTheme === 'light' ? 'dark' : 'light';

  localStorage.setItem('theme', newTheme);

  dispatch({
    type: TOGGLE_THEME,
    payload: newTheme
  });
};

// Set a specific theme (light or dark)
export const setTheme = theme => dispatch => {
  if (theme !== 'light' && theme !== 'dark') {
    console.error('Invalid theme. Must be "light" or "dark"');
    return;
  }

  localStorage.setItem('theme', theme);

  dispatch({
    type: SET_THEME,
    payload: theme
  });
};

// Initialize theme from localStorage. Light mode is the default: dark mode
// only applies when the user has explicitly chosen it before (persisted in
// localStorage). We intentionally do NOT follow the OS prefers-color-scheme,
// so a visitor on a dark-themed device still lands on light mode first.
export const initializeTheme = () => dispatch => {
  const theme = localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';

  dispatch({
    type: SET_THEME,
    payload: theme
  });
};
